<!--
 * @Description: 结算账户列表页面
 * @Author: gaohc
 * @Date: 2023-10-18 16:43:52
-->
<template>
  <div class="body">
    <div v-if="!showNodata">
      <el-row class="search-row-margin" :gutter="0" type="flex" justify="space-between">
      <el-col :span="8" style="text-align: left;">
        <span class="search-title-wrap">机构名称：</span>
        <el-select size="small" filterable v-model="filterParams.institutionId" clearable placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
          style="width: 217px;">
          <el-option v-for="item in institutionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" v-if="showAttendantMenu" style="text-align: left;">
        <span class="search-title-wrap">人员信息：</span>
        <el-input size="small" style="width: 186px;" v-model="attendantNameOrMobile" 
          clearable placeholder="姓名/手机号/身份证号">
        </el-input>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" 
          style="width: 80px;">
          搜 索
        </el-button>      
      </el-col>      
    </el-row>
    <div class="main-page-divider"></div>
    <div class="acct-msg-wrap">
      <div class="header-msg-wrap">
        <div class="member-number">
          <span style="color: #7C899A;">钱账通会员号：</span>
          <span>
            {{ settlemAccData.lklMemberNo ? settlemAccData.lklMemberNo : '- -' }}
          </span>
        </div>
        <div class="bank-msg-wrap">
          <div v-if="settlemAccData.bankDo">
            <span style="color: #7C899A;">银行账户：</span>
            <span>{{ settlemAccData.bankDo.bankName }}</span>
            <span style="margin-left: 10px">{{ settlemAccData.bankDo.bankCardNo }}</span>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="content-msg">
        <el-row type="flex" class="row-bg">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="msg-title">可提现余额(元)：</div>
              <div class="withdrawal-wrap">
                <div>{{ settlemAccData.canWithdrawAmountYuan }}</div>
                <div class="withdrawal-btn" v-if="showOprtBtn && dataPvgList.includes('INCOME_3_WITHDRAW')"
                  :style="{'opacity': !parseFloat(settlemAccData.canWithdrawAmountYuan) ? 0.4 : 1}"
                  @click="handleWithdrawBtnClick">
                  提现
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple-light">
              <div class="msg-title">服务收入(元)：</div>
              <div>{{ settlemAccData.generalIncomeAmountYuan }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <div class="msg-title title-wrap">
                <span>在途收入(元)：</span>
                <el-tooltip placement="top" title="" width="306" trigger="hover"
                  effect="dark" :content="settlemAccData.withdrawDays ? '分账成功后计为在途收入，'
                    + settlemAccData.withdrawDays + '天后计为可提现余额'
                    : '分账成功后计为在途收入，同时计入可提现余额'">
                    <img class="icon-description" 
                     src="@/assets/common/img-common-description.png" alt="">
                </el-tooltip>
              </div>
              <div>{{ settlemAccData.underwayIncomeAmountYuan }}</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <div class="msg-title">
                <span>已提现金额(元)：</span>
                <el-tooltip placement="top" title="" width="306" trigger="hover"
                  effect="dark" content="提现成功的金额">
                    <img class="icon-description" 
                     src="@/assets/common/img-common-description.png" alt="">
                </el-tooltip>
              </div>
              <div>{{ settlemAccData.withdrawAmountYuan }}</div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <div class="msg-title">
                <span>欠款(元)：</span>
                <el-tooltip placement="top" title="" width="306" trigger="hover"
                  effect="dark" content="订单发生协商退款，本平台为服务收款方垫付的金额">
                    <img class="icon-description" 
                     src="@/assets/common/img-common-description.png" alt="">
                </el-tooltip>
              </div>
              <div>{{ settlemAccData.debtAmountYuan }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="chart-wrap">
        <div class="income-chart-item" style="margin-right: 30px;">
          <div class="chart-header">
            收入类别 (单位: 元)
          </div>
          <div style="width: 100%; height: 300px" id="incomeChart" ref="echarts"></div>
        </div>
        <div class="income-chart-item">
          <div class="chart-header">
            支出类别 (单位: 元)
          </div>
          <div style="width: 100%; height: 300px" id="payChart" ref="echarts"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty style="margin-top: 150px;" description="暂无数据"></el-empty>
    </div>
      <!-- 选择人员弹窗 -->
      <sel-docnurse-dlg :visible="showSelDocnurseDlg" 
        :attendantList="attendantList" @hanle-select="handleSelectAttendant"
        @close-dialog="showSelDocnurseDlg = false" />

      <!-- 申请提现弹窗 -->
      <apply-withdraw-dlg :visible="showApplyWithdrawDlg" 
        :institutionId="filterParams.institutionId"
        @handle-withdraw = "handleWithdraw"
        @close-dialog="showApplyWithdrawDlg = false" />

      <submit-withdraw-dlg :visible="showSubmitWithdrawDlg"
        :withdrawData="withdrawData"
        @close-dialog="showSubmitWithdrawDlg = false" />
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from "@/global/Util.js";
import SelDocnurse from './components/settlementacctlist/SelDocnurse.vue'
import ApplyWithdraw from './components/settlementacctlist/ApplyWithdraw.vue'
import SubmitWithdraw from './components/settlementacctlist/SubmitWithdraw.vue'

export default {
  name: 'SettlementAcctList',
  
  components:{
    "sel-docnurse-dlg": SelDocnurse,
    "apply-withdraw-dlg": ApplyWithdraw,
    "submit-withdraw-dlg": SubmitWithdraw
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      showAttendantMenu: false,     //是否显示人员筛选框
      institutionList: [],
      srcInstitutionList: [],
      filterParams: {
        institutionId: null,
        attendantId: null
      },
      attendantNameOrMobile: '',
      settlemAccData: {},
      showOprtBtn: true,
      
      showNodata: false,

      inconmeColors: ["#40C7E9", "#3C85FF", "#3EB699", "#8BCD55"],
      payColors: ["#78A3FF", "#EC6767", "#F0976C"],

      attendantList: [],       //查询人员信息返回的人员列表
      showSelDocnurseDlg: false,
      showApplyWithdrawDlg: false,

      withdrawData: {},       //提现成功弹窗展示数据
      showSubmitWithdrawDlg: false
    }
  },
  
  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      if (!this.institutionList.length) {
        this.showNodata = true;
        return
      }
      this.filterParams.institutionId = this.institutionList[0].id;
      this.getSettlementAcctDO();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INCOME'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },
    
    //过滤条件接口调用
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_SETTLEMENT_ACCT_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data.simpleInstitutionList;
            this.srcInstitutionList = result.data.simpleInstitutionList;
            this.showAttendantMenu = result.data.showAttendantMenu;
            resolve();
          }
        })
      })
    },

    //获取人员信息是否重名
    getAttendantIsRepeat() {
      let params = {
        institutionId: this.filterParams.institutionId,
        attendantMobOrNameOrIdNo: this.attendantNameOrMobile
      }
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_LIST_LKL_MERCHANT_ATTENDANTS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.attendantList = result.data;
          this.queryAttendantAcctData();
        }
      });
    },

    //查询人员信息数据处理
    queryAttendantAcctData() {
      if (!this.attendantList.length) {
        this.$message({
          message: '未查询到该人员信息，请重新输入！',
          type: 'warning'
        });
        return
      }

      if (this.attendantList.length == 1) {
        this.filterParams.attendantId = this.attendantList[0].id;
        this.getSettlementAcctDO();
        return
      }

      this.showSelDocnurseDlg = true;
    },

    //获取结算账户主页DO
    getSettlementAcctDO() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_SETTLEMENT_ACCT_DO,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.settlemAccData = result.data;
            this.settlemAccData.canWithdrawAmountYuan = Util.formattedAmount(this.settlemAccData.canWithdrawAmountYuan);
            this.settlemAccData.generalIncomeAmountYuan = Util.formattedAmount(this.settlemAccData.generalIncomeAmountYuan);
            this.settlemAccData.underwayIncomeAmountYuan = Util.formattedAmount(this.settlemAccData.underwayIncomeAmountYuan);
            this.settlemAccData.withdrawAmountYuan = Util.formattedAmount(this.settlemAccData.withdrawAmountYuan);
            this.settlemAccData.debtAmountYuan = Util.formattedAmount(this.settlemAccData.debtAmountYuan);
            this.drawCharts('incomeChart', this.settlemAccData.incomePieChartDOList);
            this.drawCharts('payChart', this.settlemAccData.payPieChartDOList);
            resolve();
          }
        })
      })
    },

    drawCharts(idName, data) {
      let lengendData = data;
      let myChart = this.echarts.init(document.getElementById(idName));
      myChart.setOption({
        title: {
          text: idName == 'incomeChart' ? '总收入' : '总支出',//主标题文本
          subtext: idName == 'incomeChart' ? this.settlemAccData.incomeTotalAmountYuan 
            : this.settlemAccData.payTotalAmountYuan,//副标题文本
          left: '24%',
          top: '40%',
          textAlign: 'center',
          textStyle: {
          fontSize: 15,
          color: '#7C899A',
          align: 'center'
          },
          subtextStyle: {
            fontFamily : "微软雅黑",
            fontSize: 24,
            color:'#333333',
            align:'center'
          }
        },
        color: idName == 'incomeChart' ? this.inconmeColors : this.payColors,
        tooltip: { trigger: "item", formatter: "{b}   {d}%    {c}" },
        legend: {
          type: "scroll",
          orient: "vertical", //图例的布局，水平布局、垂直布局
          icon: "circle",
          itemWidth: 8, //图例宽度
          itemHeight: 8, //图例高度
          padding: 0,
          itemGap: 15, //图例之间的间隙
          top: 100,
          right: 50,
          bottom: 20,
          formatter: function (name) {
            // 获取legend显示内容
            let p = 0;
            let amount;
            let arr = lengendData.map((x) => {
              return x.value * 1;
            });
            for (let i = 0, l = lengendData.length; i < l; i++) {
              if (lengendData[i].name == name) {
                p = Util.getPercentValue(arr, i, 2);
                amount = lengendData[i].value;
              }
            }
            return `{one|${name}}` + `{two|${p}%}` + `{three|${amount}}`;
          },
          textStyle: {
            rich: {
              one: {width: 70, color: "#333333", fontSize: 12, align: 'left'},
              two: {width: 60, color: "#333333", fontSize: 12, align: 'right'},
              three: {width: 100, color: "#333333", fontSize: 12, align: 'right'},
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            center: ["25%", "50%"], //圆的位置
            label: { normal: {show: false} },
            labelLine: {show: false},
            data: data,
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    handleWithdrawBtnClick() {
      if (!parseFloat(this.settlemAccData.canWithdrawAmountYuan)) return
      this.showApplyWithdrawDlg = true;
    },

    handleSelectAttendant(attendantId) {
      this.filterParams.attendantId = attendantId;
      this.showSelDocnurseDlg = false;
      this.getSettlementAcctDO();
    },

    handleWithdraw(withdrawData) {
      this.getSettlementAcctDO();
      this.showApplyWithdrawDlg = false;
      this.withdrawData = withdrawData;
      this.showSubmitWithdrawDlg = true;
    },

    handleQuery() {
      if (!this.filterParams.institutionId || (!this.filterParams.institutionId 
        && this.attendantNameOrMobile)) {
        this.$message({
          message: '请选择查询机构',
          type: 'warning'
        });
        return
      }

      if (this.attendantNameOrMobile) {
        this.showOprtBtn = false;
        this.getAttendantIsRepeat();
      } else {
        this.filterParams.attendantId = null;
        this.showOprtBtn = true;
        this.getSettlementAcctDO();
      }
    },
  },
  
  mounted() {
    this.$emit("breadcrumb", {text1: '财务管理',text2: '结算账户'});
		this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
.acct-msg-wrap {
  background: #F5F7FA;
  border: 1px solid #E4E7ED;
  margin: 30px 40px;
  padding: 30px 0;
  color: #333333;
  font-size: 15px;
  text-align: left;
}
.member-number {
  min-width: 330px;
}
.bank-msg-wrap, .header-msg-wrap, .withdrawal-wrap, .title-wrap {
  display: flex;
  align-items: center;
}
.header-msg-wrap {
  margin: 0 20px;
}
.bank-mng {
  width: 117px;
  height: 29px;
  line-height: 29px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #3E7EF5;
  color: #3E7EF5;
  margin-left: 20px;
  cursor: pointer;
}
.line {
  height: 1px;
  background-color: #D7DDE5;
  margin: 20px 0;
}
.content-msg {
  margin: 0 20px;
  color: #333333;
  font-size: 32px;
  font-weight: bold;
  word-break: break-all;
}
.msg-title {
  color: #7C899A;
  font-size: 15px;
  margin-bottom: 4px;
  font-weight: normal;
}
.withdrawal-btn {
  width: 58px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #3E7EF5;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 15px;
  margin-left: 18px;
  cursor: pointer;
}
.icon-description {
  width: 15px;
  height: 14px;
  cursor: pointer;
  vertical-align: middle;
}
.chart-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 40px;
}
.income-chart-item {
  width: 530px;
  height: 356px;
  background: #FFFFFF;
  border: 1px solid #E4E7ED;
  flex: 1;
}
.chart-header {
  padding: 28px 20px 27px 20px;
  color: #5B5B5B;
  font-size: 16px;
  text-align: left;
  border-bottom: 1px solid #D7DDE5;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/SettlementAcctList.vue